import api from "../utils/axios";
export async function getDeliverySchedules1() {
  try {
    const response = await api.get(`/auth/delivery-schedules`);

    return response.data.schedules;
  } catch (error) {
    console.error("Failed to load delivery schedules:", error);

    throw error;
  }
}

export const getDeliverySchedules = async () => {
  const response = await api.get(`/auth/delivery-schedules`);

  return response.data?.schedules ?? [];
};

export const getShippingMethods = async () => {
  const response = await api.get("/auth/shipping-methods");

  return response.data?.data ?? [];
};

export const getShippingPrice = async ({ code, lat = null, lng = null }) => {
  /*
    |--------------------------------------------------------------------------
    | Make absolutely sure code is a string
    |--------------------------------------------------------------------------
    */

  const normalizedCode = typeof code === "string" ? code.trim() : code?.code;

  if (!normalizedCode || typeof normalizedCode !== "string") {
    throw new Error("Shipping method code is invalid.");
  }

  const payload = {
    code: normalizedCode,
  };

  if (lat !== null && lng !== null) {
    payload.lat = Number(lat);
    payload.lng = Number(lng);
  }

  const response = await api.post("/auth/shipping-methods/price", payload);

  return response.data?.data;
};
